export function setupMoveProductData() {
    if (document.querySelector('.fillProductNumber') && document.getElementById('productNumber')) {
        let productNumber = document.getElementById('productNumber').innerText.toLowerCase();

        productNumber = productNumber.charAt(0).toUpperCase() + productNumber.slice(1)

        Array.from(document.querySelectorAll('.fillProductNumber')).forEach(element => {
            const type = element.nodeName.toLowerCase();

            switch(type) {
                case 'input':
                    element.value = productNumber;
                    break;

                default:
                    element.innerText = productNumber;
                    break;
            }
        });
    }

    if (document.querySelector('.fillProductName') && document.getElementById('productName')) {
        const productName = document.getElementById('productName').innerText;

        Array.from(document.querySelectorAll('.fillProductName')).forEach(element => {
            const type = element.nodeName.toLowerCase();

            switch (type) {
                case 'input':
                    element.value = productName;
                    break;

                default:
                    element.innerText = productName;
                    break;
            }
        });
    }

    Array.from(document.querySelectorAll('.swap-link')).forEach(link => {
        const newHref = link.getAttribute('data-link');

        link.setAttribute('href', newHref);
        link.removeAttribute('data-link');
    });

    Array.from(document.querySelectorAll('.rich-text a, .header__ctas a')).forEach(link => {
        const oldHref = link.getAttribute('href');

        if (oldHref && oldHref.indexOf('DWSDownload.aspx') > -1) {
            const newHref = oldHref.split('File=')[1];
            link.setAttribute('href', newHref);
        }
    });
}
